<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="kfc_home_slider">
    <div class="__home_slider_wrap">
      <Slider />
    </div>
  </div>
  <div class="menu_container">
    <div class="top_tab">
      <div class="container">
        <div class="menu_wrap">
          <div class="left_menu">
            <div class="current_menu __kfc_r_3">
              {{ orderType === 2 ? $t('pickupMenu') : $t('deliveryMenu') }}
            </div>
            <div class="menu_items">
              <div @click="changeOrderType(2)" class="nav-item __kfc_button" :class="orderType === 2 ? 'active' : ''">
                <div class="image">
                  <img v-if="orderType === 2" src="@/assets/icons/pickupWhite.svg" alt="">
                  <img v-else src="@/assets/icons/pickupBlack.svg" alt="">
                  <img class="__kfc_image_hover" src="@/assets/icons/hoverPickup.svg" alt="">
                </div>
                <span class="__kfc_r_5">{{ $t('pickup') }}</span>
              </div>
              <div @click="changeOrderType(1)" class="nav-item __kfc_button" :class="orderType === 1 ? 'active' : ''">
                <div class="image">
                  <img v-if="orderType === 1" src="@/assets/icons/electricCarWhite.svg" alt="">
                  <img v-else src="@/assets/icons/electricCarBlack.svg" alt="">
                  <img class="__kfc_image_hover" src="@/assets/icons/hoverElectricCar.svg" alt="">
                </div>
                <span class="__kfc_r_5">{{ $t('delivery') }}</span>
              </div>
            </div>
          </div>
          <div class="right_menu" ref="orderRef">
            <search-address v-if="orderType === 1" classes="__main_address_input" type="main" />
            <select-store v-if="orderType === 2" :value="pickupValue" :key="pickupValue"></select-store>
            <current-location />
            <button class="__kfc_button kfc_map" @click="() => { showRoadMap = true }">
              <div class="image">
                <img src="@/assets/icons/Location-Black.svg" alt="">
                <img class="__kfc_image_hover" src="@/assets/icons/Location-Red.svg" alt="">
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <SidebarMenu v-if="!showSidebarMenu" :showSidebarMenu="showSidebarMenu" />
    </div>
  </div>
  <div class="__kfc_content">
    <SidebarMenu v-if="showSidebarMenu" :showSidebarMenu="showSidebarMenu" />
    <div class="container content">
      <MainMenu :showSliderProduct="showSliderProduct" :key="showSliderProduct + 'a'">
        <template #products="{ menus }">
          <product-item @click="productDetail(menuItem)" :menuItem="menuItem" v-for="(menuItem) in menus"
            :key="menuItem" />
        </template>
        <template #sliderProducts="{ menuItem }">
          <product-item @click="productDetail(menuItem)" :menuItem="menuItem" :key="menuItem" />
        </template>
      </MainMenu>
      <div class="rewards __kfc_flex">
        <div class="rewards-image">
        </div>
        <div class="rewards-box __kfc_flex">
          <span class="text">Sign in to save all your rewards.</span>
          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
            <circle opacity="0.2" cx="25.0859" cy="25.9053" r="25" fill="white" />
          </svg> -->
          <div class="button">
            <a href="https://www.facebook.com/KFC.Mongolia" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path
                  d="M13.3 17.6801C13.1 17.4801 13.004 17.2384 13.012 16.9551C13.02 16.6717 13.1243 16.4301 13.325 16.2301L16.15 13.4051H5C4.71667 13.4051 4.479 13.3091 4.287 13.1171C4.095 12.9251 3.99934 12.6877 4 12.4051C4 12.1217 4.096 11.8841 4.288 11.6921C4.48 11.5001 4.71734 11.4044 5 11.4051H16.15L13.3 8.55508C13.1 8.35508 13 8.11741 13 7.84208C13 7.56674 13.1 7.32941 13.3 7.13008C13.5 6.93008 13.7377 6.83008 14.013 6.83008C14.2883 6.83008 14.5257 6.93008 14.725 7.13008L19.3 11.7051C19.4 11.8051 19.471 11.9134 19.513 12.0301C19.555 12.1467 19.5757 12.2717 19.575 12.4051C19.575 12.5384 19.554 12.6634 19.512 12.7801C19.47 12.8967 19.3993 13.0051 19.3 13.1051L14.7 17.7051C14.5167 17.8884 14.2877 17.9801 14.013 17.9801C13.7383 17.9801 13.5007 17.8801 13.3 17.6801Z"
                  fill="white" />
              </svg>
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>

  <message-popup v-if="showSelectAddress" @handleClose="toAddressFocus">
    <template #headerIcon>
      <img v-show="orderType === 1" src="@/assets/icons/hoverCar.svg" alt="">
      <img v-show="orderType === 2" :style="{ width: '75px', height: '75px' }" src="@/assets/icons/hoverPickup.svg"
        alt="">
    </template>
    <template #content>
      <div class="title">
        <span v-if="orderType === 1">{{ $t('chooseDeliveryAddress') }}</span>
        <span v-if="orderType === 2">{{ $t('choosePickupAddress') }}</span>
      </div>
      <!-- <img src="@/assets/gifs/add-product-success.gif" alt=""> -->
    </template>
    <template #actions>
      <button @click="toAddressFocus" class="__kfc_button __kfc_r_6 __kfc_button_cancel">{{ $t('close') }}</button>
    </template>
  </message-popup>
  <product-detail-popup v-if="showProductDetail" :instance="selectedProduct" @handleClose="removeInstance" />
  <RoadMap v-if="showRoadMap" @handleClose="() => { showRoadMap = false }" />
</template>

<script>
import { useStore } from 'vuex'
import { computed, inject, onMounted, onUnmounted, ref, nextTick, watch } from 'vue';
import Slider from '@/components/BannerSlider.vue'
import SelectStore from '@/components/SelectStore.vue'
import Req from '@/utils/Request';
import SidebarMenu from '@/components/SidebarMenu.vue';
import MainMenu from '@/components/MainMenu.vue';
import ProductItem from '@/components/ProductItem.vue'
import MessagePopup from '@/components/MessagePopup.vue';
import ProductDetailPopup from '@/components/ProductDetailPopup.vue';
import { useRoute } from 'vue-router'
import CurrentLocation from '@/components/CurrentLocation.vue';
import SearchAddress from '@/components/SearchAddress.vue';
import RoadMap from '@/components/RoadMap.vue';

export default {
  components: {
    Slider,
    SelectStore,
    SidebarMenu,
    MainMenu,
    ProductItem,
    MessagePopup,
    ProductDetailPopup,
    CurrentLocation,
    SearchAddress,
    RoadMap
  },
  setup () {

    const route = useRoute()
    const store = useStore();
    const root = inject('app');
    const orderType = computed(() => store.getters['address/getOrderType'])
    const hasDeliveryAddress = computed(() => store.getters['address/hasDeliveryAddress'])
    const hasPickupAddress = computed(() => store.getters['address/hasPickupAddress'])
    const orderRef = ref(null);
    const showSelectAddress = ref(false);
    const showProductDetail = ref(false);
    const showRoadMap = ref(false);
    const selectedProduct = ref(null);
    const currentAddress = ref(null);
    const showSidebarMenu = ref(true);
    const showSliderProduct = ref(false);
    const windowWidth = ref(document.documentElement.clientWidth);
    const pickupAddress = computed(() => store.getters['address/getPickupAddress']);
    const pickupValue = ref(pickupAddress.value);
    localStorage.removeItem("purchase-data");

    const isMonpay = async () => {
      if (route.query.from == 'monpay') {
        root.directFrom = 'monpay'
        root.monpay.code = route.query.code
        let payload = {
          code: route.query.code
        }
        const { data: result } = await Req({
          url: "/getMonpayUserinfo",
          hideSuccess: true,
          type: 2,
          body: payload
        });
        if (result.success) {
          let user = []
          user.name = result.result.userFirstname,
            user.phone = result.result.userPhone
          user.email = result.result.userEmail ? result.result.userEmail : null
          root.monpay.accessToken = result.result.accessToken
          store.dispatch('user/setUser', user)
        } else {
          console.log('error')
        }
      }
    }
    const isMobile = () => {
      if (window.screen.width < 769) {
        root.isMobile = true
      }
    }
    const changeOrderType = (type) => {
      store.dispatch('address/updateOrderType', type)
      // store.dispatch('order/updateOptions', { order_type: type })
      getWebMenuCategories();
    }
    const getWebMenuCategories = async () => {
      const { data: result } = await Req({ url: '/menu/getWebMenuCategories', body: { order_type: orderType.value }, hideSuccess: true })
      if (result.success) {
        store.dispatch('menu/setAllCategory', result.result.sort((a, b) => parseInt(a.category_sort) - parseInt(b.category_sort)))
      }
    }
    const toAddressFocus = async () => {
      showSelectAddress.value = false;
      await nextTick()
      orderRef.value.querySelector('.el-input__inner').focus()
    }

    const productDetail = (product) => {
      if (product.disabled) return;
      const hasAddress = orderType.value === 1 ? hasDeliveryAddress : hasPickupAddress;
      if (!hasAddress.value) {
        showSelectAddress.value = true
      } else {
        selectInstance(product)
      }
    }

    const selectInstance = (product) => {
      showProductDetail.value = true
      selectedProduct.value = product
    }
    const removeInstance = () => {
      showProductDetail.value = false
      selectedProduct.value = null
    }

    const isShowSidebarMenu = () => {
      if (windowWidth.value < 1320) {
        showSidebarMenu.value = false;
      } else {
        showSidebarMenu.value = true;
      }
    }
    const isShowSliderProduct = () => {
      if (windowWidth.value < 768) {
        showSliderProduct.value = true;
      } else {
        showSliderProduct.value = false;
      }
    }
    const windowResizer = () => {
      windowWidth.value = document.documentElement.clientWidth;
      isShowSidebarMenu()
      isShowSliderProduct()
    }
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const menuCats = document.querySelectorAll('.page-scroll');
      const menu_container = document.querySelector('.menu_container').offsetHeight;
      const contentOffsetTop = document.querySelector('.__kfc_content').offsetTop;
      const sidebar_container = showSidebarMenu.value ? document.querySelector('.sidebar_container') : document.querySelector('.scroll-menu');
      menuCats.forEach((menu) => {
        let target = document.querySelector(menu.dataset.id);
        if (target) {
          if (target.offsetTop + contentOffsetTop - menu_container <= scrollY) {
            sidebar_container.querySelector('.active').classList.remove('active');
            menu.querySelector('.side-item').classList.add('active');
          }
        }
      });

      const horizontalCategory = document.querySelector('.horizontalCategory');
      if (horizontalCategory && horizontalCategory.querySelector('.active')) {
        let scroll = horizontalCategory.querySelector('.active').closest('.category-item').offsetLeft - horizontalCategory.offsetLeft;
        document.querySelector('.horizontalCategory').scrollTo(scroll, 0);
      }
    };

    onMounted(() => {
      isShowSidebarMenu()
      isShowSliderProduct()
      window.addEventListener('resize', windowResizer);
      window.addEventListener('scroll', handleScroll);
    })

    onUnmounted(() => {
      window.removeEventListener('resize', windowResizer);
      window.removeEventListener('scroll', handleScroll);
    });

    isMonpay();
    getWebMenuCategories();
    isMobile();
    return {
      orderType,
      orderRef,
      showSelectAddress,
      showProductDetail,
      selectedProduct,
      currentAddress,
      showRoadMap,
      showSidebarMenu,
      showSliderProduct,
      pickupValue,
      changeOrderType,
      getWebMenuCategories,
      productDetail,
      toAddressFocus,
      removeInstance,


    }
  }
}
</script>
<style lang="scss" scoped>
.kfc_home_slider {
  overflow: hidden;
}

.menu_container {
  position: sticky;
  top: 0;
  z-index: 2;
  background: $whiteMain;

  .top_tab {
    background: $dark5;
  }

  .menu_wrap {
    display: flex;
    padding: 25px 0;
    align-items: center;
    width: 100%;
    gap: 30px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
    }

    .left_menu {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 50%;
      height: 60px;
      gap: 24px;

      @media (max-width: 768px) {
        width: 100%;
        height: 50px;
      }

      // padding: 25px 25px 25px 0;
      .current_menu {
        flex-shrink: 0;

        @media (max-width: 1023px) {
          display: none;
        }
      }

      .img_box {
        position: relative;
        width: 35px;
        height: 100%;

        img {
          position: absolute;
        }
      }
    }

    .right_menu {
      display: grid;
      grid-template-columns: 1fr 60px 60px;
      gap: 10px;
      border: none;
      width: 50%;
      height: 60px;

      @media (max-width: 768px) {
        width: 100%;
        grid-template-columns: 1fr 48px 48px;
        height: 48px;

      }

      .kfc_map {
        background: $whiteMain;
        padding: 0;

        .image {
          position: relative;

          img {
            width: 25px;
            height: 25px;
          }
        }

        &:hover {
          .__kfc_image_hover {
            opacity: 1;
          }

          @media (max-width: 768px) {
            .__kfc_image_hover {
              opacity: 0;
            }
          }
        }
      }

      // button {
      //   border-radius: 4px;
      //   background: $whiteMain;
      //   border: none;
      //   cursor: pointer;
      //   padding: 18px;
      // }
    }
  }



  .menu_items {
    display: flex;
    width: 100%;
    height: 100%;

    .nav-item {
      display: flex;
      align-items: center;
      gap: 16px;
      border-radius: 4px;
      background: $whiteMain;
      cursor: pointer;
      flex: 1;
      position: relative;

      .image {
        position: relative;
      }

      &:not(.active):hover {
        .__kfc_image_hover {
          opacity: 1;
        }

        @media (max-width: 768px) {
          .__kfc_image_hover {
            opacity: 0;
          }
        }
      }

      span.__kfc_r_5 {
        width: max-content;
      }
    }

    .nav-item.active {
      background: $darkMain;
      color: $whiteMain;
      box-shadow: 1px 4px 14px 0px rgba(0, 33, 71, 0.07);
    }
  }


}

.__home_slider_wrap {
  position: relative;
  overflow: hidden;
}

.__kfc_content {
  position: relative;
  width: 100%;
  height: 100%;

  .content {
    position: relative;
    background: $whiteMain;
    padding-top: 30px;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
}

.rewards {
  width: 100%;
  height: 200px;

  @media (max-width: 768px) {
    height: auto;
    flex-direction: column;

  }

  .rewards-image {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    width: 60%;
    height: 100%;
    // background-image: "@/assets/images/rewards.png";
    background-image: url('@/assets/images/rewards.png');
    // background-size: cover;
    background-position: center;

    @media (max-width: 768px) {
      width: 100%;
      height: 200px;
      border-top-right-radius: 4px;
      border-bottom-left-radius: 0;
    }
  }

  .rewards-box {
    background: $redMain;
    padding: 60px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    width: 40%;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
      width: 100%;
      flex-direction: column;
      padding: 30px;
      border-bottom-left-radius: 4px;
      border-top-right-radius: 0;
    }

    .button {
      display: flex;
      width: 50px;
      height: 50px;
      background: $whiteMain;
      border-radius: 50%;
      flex-shrink: 0;
      background: rgba(255, 255, 255, 0.2);
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: ease-in 0.1s;

      &:hover {
        background: rgba(255, 255, 255, 0.5);

      }
    }

    .text {
      font-family: Oswald;
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      color: $whiteMain;
      line-height: 42px;
    }
  }
}
</style>
